import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import vuetify from '@/plugins/vuetify';
import mixins from './extensions/mixins';
import pinia from '@/plugins/pinia';

/** Tailwind CSS **/
import '@/assets/style/tailwind.scss';

/**Globally registering all framework components */
import '@/framework';

/** plugins **/
import '@/plugins/vue-mask';
import '@/plugins/vue-query';
import '@/plugins/vue-portal';
import '@/plugins/vue-echarts';
import '@/plugins/vue-toasted';
import '@/plugins/vue-html2pdf';
import '@/plugins/vue-calendar';
import '@/plugins/vue-datepicker';
import '@/plugins/vue-tel-input';
import '@/plugins/vue-perfect-scrollbar';
import '@/plugins/sentry';

/** Filters **/
import '@/extensions/filters';

Vue.config.productionTip = false;

Vue.mixin(mixins);

Vue.prototype.$window = window;
Vue.prototype.$document = document;

new Vue({
  router,
  vuetify,
  i18n,
  pinia,
  render: (h) => h(App),
}).$mount('#app');
